export default __webpack_public_path__ + "static/media/a011-example7.a471a867.jpg";